/*
	La foto del curso -- y nada, si el curso no tiene foto.

	Antes, cuando no habia foto, se caia a un dibujo de unos libros que no decia
	nada de nada. En un telefono ese dibujo se comia media pantalla antes de que
	se llegara al primer dato del horario. (Esteban, 2026-09-20)
*/
const FotoDelCurso = ({src} : {src? : string | null}) =>
	!src ? null :
	<div className="waFotoCurso">
		<img className="relatedPicture" src={src} alt="" />
	</div>

export default FotoDelCurso
